module.exports = __webpack_public_path__ + "static/media/dashboard.c1e4ec0f.png";